import { MAX_OPPORTUNITIES } from "../../../utils/opportunitySelection";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function OpportunityQuickPick({
    selected = [],
    onViewAll,
    disabled = false,
}) {
    const selectedCount = selected.length;

    if (disabled) return null;

    return (
        <div className="my-4 mx-6 sm:mx-0">
            <button
                type="button"
                onClick={onViewAll}
                className="group inline-flex w-full items-center justify-center gap-1.5 rounded-xl border border-slate-900 bg-slate-900 px-4 py-3 text-sm font-semibold text-white shadow-md shadow-slate-900/20 transition hover:bg-slate-800 sm:w-auto sm:rounded-lg sm:py-2.5"
            >
                Choose trends
                <i
                    className="bi bi-arrow-right-short text-base leading-none transition-transform group-hover:translate-x-0.5"
                    aria-hidden
                />
            </button>
            <p className="mt-2 text-xs text-slate-500 md:text-sm">
                {selectedCount}/{MAX_OPPORTUNITIES} selected
            </p>
        </div>
    );
}
